/* Guarda Mundo — viewport height estável (mobile URL bar).
   Congela innerHeight p/ layout; emite gm:vv-chrome quando só a altura
   visual muda (barra some/aparece) pra consumidores reancorarem animação. */

(() => {
  if (window.gmStableVh) return;

  let px = Math.round(window.innerHeight);
  let width = window.innerWidth;
  let gen = 0;
  const WIDTH_EPS = 8;
  const CHROME_EPS = 24;

  const publish = () => {
    const next = `${px}px`;
    if (document.documentElement.style.getPropertyValue('--gm-stable-vh') === next) return;
    document.documentElement.style.setProperty('--gm-stable-vh', next);
  };

  /**
   * @param {boolean} force
   * @returns {boolean} true se gen avançou (largura / orientation)
   */
  const sync = (force) => {
    const w = window.innerWidth;
    const h = Math.round(window.innerHeight);
    const widthChanged = Math.abs(w - width) >= WIDTH_EPS;
    if (!force && !widthChanged) return false;
    width = w;
    px = h;
    gen += 1;
    publish();
    return true;
  };

  publish();

  window.addEventListener('resize', () => sync(false), { passive: true });
  window.addEventListener('orientationchange', () => {
    window.setTimeout(() => sync(true), 350);
  });

  /* URL bar: altura do visualViewport muda sem mudar largura. */
  const vv = window.visualViewport;
  let lastVvH = vv ? Math.round(vv.height) : px;
  let lastVvOffset = vv ? vv.offsetTop : 0;

  const emitChrome = () => {
    if (!vv) return;
    const h = Math.round(vv.height);
    const offsetTop = vv.offsetTop;
    const dh = h - lastVvH;
    const dOffset = offsetTop - lastVvOffset;
    if (Math.abs(dh) < CHROME_EPS && Math.abs(dOffset) < 2) return;
    lastVvH = h;
    lastVvOffset = offsetTop;
    window.dispatchEvent(
      new CustomEvent('gm:vv-chrome', {
        detail: { dh, height: h, offsetTop, dOffset },
      })
    );
  };

  if (vv) {
    vv.addEventListener('resize', emitChrome, { passive: true });
    vv.addEventListener('scroll', emitChrome, { passive: true });
  }

  window.gmStableVh = {
    px: () => px,
    /** Incrementa só em mudança de largura / orientation (não URL bar). */
    gen: () => gen,
  };
})();
